<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">月次運賃ハンド対応・AR</span>
      </v-card-title>

      <v-card-actions>
        <v-btn :disabled="query.status === '承認済' || forzen" @click="save"
          >登録</v-btn
        >
        <v-btn @click="$router.push('B2000')">戻る</v-btn>
        <v-btn
          :disabled="query.status === '承認済' || forzen"
          @click="confirm"
          v-if="query.id && isAdmin"
          v-permit.SHARP_FU_ARAP_MANUAL_CONFIRM
          >承認</v-btn
        >
        <v-btn
          :disabled="query.status === '承認待' || forzen"
          @click="cancelConfirm"
          v-if="query.id && isAdmin"
          v-permit.SHARP_FU_ARAP_MANUAL_CONFIRM_CANCEL
          >承認取消</v-btn
        >
        <v-btn
          :disabled="forzen"
          @click="upload"
          v-if="query.id"
          v-permit.SHARP_FU_ARAP_MANUAL_UPLOAD
          >ファイルアップロード</v-btn
        >
        <v-btn
          :disabled="forzen"
          @click="download"
          v-if="query.id"
          v-permit.SHARP_FU_ARAP_MANUAL_DOWNLOAD
          >ファイルダウンロード</v-btn
        >
        <v-btn
          :disabled="query.status === '承認待'"
          @click="pdfDownload"
          v-if="query.id"
          v-permit.SHARP_FU_ARAP_MANUAL_EXPORT_PDF
          >承認帳票出力</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-radio-group
                :mandatory="false"
                row
                v-model="query.documentType"
              >
                <v-radio label="DR" value="DR"></v-radio>
                <v-radio label="ZX" value="ZX"></v-radio>
                <v-radio label="DG" value="DG"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="事業本部"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="通貨コード"
                url="currencies/kv"
                v-model="query.currencyCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :readonly="true"
                label="Reference document number"
                v-model="query.referenceDocumentNumber"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="Posting key"
                v-model="query.postingKey"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="Account number "
                v-model="query.accountNumber"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-picker
                :min="formatYearMonth(currentMonth)"
                :value="formatYearMonth(query.archiveYearMonth)"
                @input="
                  (v) =>
                    (query.archiveYearMonth =
                      v != null ? v.replace('-', '') : null)
                "
                label="凍結年月"
                type="month"
              ></date-picker>
              <!-- <v-text-field label="凍結年月" v-model="query.archiveYearMonth"></v-text-field> -->
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="承認ステータス："
                v-model="query.status"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-select
                :items="ledger"
                clearable
                disabled
                label="General ledger account"
                v-model="query.untaxedLedgerAccount1"
              ></v-select>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label="非課税金額"
                type="number"
                v-model="query.untaxedAmount1"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label="課税金額"
                type="number"
                v-model="query.taxedAmount1"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                label="税金"
                type="number"
                v-model="tax1"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                label="税入"
                type="number"
                v-model="total1"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-select
                :items="ledger"
                clearable
                disabled
                v-model="query.untaxedLedgerAccount2"
              ></v-select>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.untaxedAmount2"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.taxedAmount2"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="tax2"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="total2"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-select
                :items="ledger"
                clearable
                disabled
                v-model="query.untaxedLedgerAccount3"
              ></v-select>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.untaxedAmount3"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.taxedAmount3"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="tax3"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="total3"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-select
                :items="ledger"
                clearable
                disabled
                v-model="query.untaxedLedgerAccount4"
              ></v-select>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.untaxedAmount4"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.taxedAmount4"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="tax4"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="total4"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-select
                :items="ledger"
                clearable
                disabled
                v-model="query.untaxedLedgerAccount5"
              ></v-select>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.untaxedAmount5"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                label
                type="number"
                v-model="query.taxedAmount5"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="tax5"
              ></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field
                disabled
                type="number"
                v-model="total5"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field disabled v-model="taxLedger"></v-text-field>
            </v-flex>
            <v-flex md2 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12></v-flex>
            <v-flex md2 sm6 xs12>
              <v-text-field disabled v-model="tax"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12></v-flex>
              <v-flex md2 sm6 xs12>非課税金額合計: {{ untaxed }}</v-flex>
              <v-flex md2 sm6 xs12>課税金額合計: {{ taxed }}</v-flex>
              <v-flex md2 sm6 xs12>税金合計: {{ tax }}</v-flex>
              <v-flex md2 sm6 xs12>税込合計: {{ total }}</v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </v-card>
    <upload-file-dialog ref="dialog"></upload-file-dialog>
    <download-doc-dialog
      :blNo="this.query.id"
      ref="dDialog"
    ></download-doc-dialog>
  </v-container>
</template>
<script>
import uploadFileDialog from './uploadFileDialog'
import downloadDocDialog from './DownloadDocDialog'
export default {
  components: { uploadFileDialog, downloadDocDialog },
  data() {
    return {
      ledger: [
        {
          text: '4101000030-陸送-運送収入',
          value: '4101000030',
        },
        {
          text: '4103000030-荷役収入',
          value: '4103000030',
        },
        {
          text: '4105000190-業務委託収入',
          value: '4105000190',
        },
        {
          text: '4101000110-航空-運送収入',
          value: '4101000110',
        },
        {
          text: '4101000070-海運-運送収入',
          value: '4101000070',
        },
      ],
      query: {
        status: '承認待',
        type: 'AR',
        postingKey: '01',
        accountNumber: 'JP05CS0163',
        taxLedger: '2108000000',
        untaxedLedgerAccount1: '4101000030',
        untaxedLedgerAccount2: '4103000030',
        untaxedLedgerAccount3: '4105000190',
        untaxedLedgerAccount4: '4101000110',
        untaxedLedgerAccount5: '4101000070',
        taxedLedgerAccount1: '4101000030',
        taxedLedgerAccount2: '4103000030',
        taxedLedgerAccount3: '4105000190',
        taxedLedgerAccount4: '4101000110',
        taxedLedgerAccount5: '4101000070',
      },
      taxLedger: '2108000000-消費税',
      expand: false,
      headers: [
        {
          text: 'Doc.no',
          sortable: false,
          value: 'docNo',
        },
        { text: '年月', value: 'yearMonth', sortable: false },
        { text: 'Document Type', value: 'documentType', sortable: false },
        { text: 'Header Text', value: 'headerText', sortable: false },
        { text: 'Currency', value: 'currency', sortable: false },
        { text: 'Posting', value: 'posting', sortable: false },
        { text: 'Account number', value: 'accountNumber', sortable: false },
        {
          text: 'General ledger account',
          value: 'generalLedgerAccount',
          sortable: false,
        },
        { text: 'Tax Code', value: 'taxCode', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false },
      ],
      results: [],
      taxRate: null,
    }
  },
  methods: {
    formatYearMonth(yearMonth) {
      if (yearMonth == null || yearMonth.trim() == '') {
        return yearMonth
      }
      return yearMonth.substring(0, 4) + '-' + yearMonth.substring(4, 6)
    },
    upload() {
      this.$refs.dialog.popup(this.query.id)
    },
    download() {
      this.$refs.dDialog.popup()
    },
    pdfDownload() {
      this.$download(`/arap/finance/${this.query.id}/ar.pdf`)
    },
    load() {
      // this.query.archiveYearMonth = new Date().format('yyyyMM')
      this.$http.get('/consumption-tax-rates/today').then((res) => {
        this.taxRate = res.data.rate
      })
      if (this.$route.query.id) {
        this.$http
          .get(`/arap/finance/get-finance/${this.$route.query.id}`)
          .then((res) => {
            this.query = res.data
          })
      } else {
        if (this.query.archiveYearMonth == null) {
          this.query.archiveYearMonth = this.currentMonth
        }
      }
    },
    save() {
      if (this.checkData()) {
        if (this.query.id) {
          this.$http
            .put('/arap/finance/update-ar', {
              ...this.query,
              tax: this.tax,
              rate: this.taxRate,
            })
            .then((res) => {
              this.$message('', 'ハンドAR作成成功')
              this.$router.push('B2000')
              console.log(res)
            })
            .catch(this.catch)
        } else {
          this.$http
            .post('/arap/finance/manual-ar', {
              ...this.query,
              tax: this.tax,
              rate: this.taxRate,
            })
            .then((res) => {
              this.$message('', 'ハンドAR作成成功')
              this.$router.push('B2000')
              console.log(res)
            })
            .catch(this.catch)
        }
      }
    },
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'ARCHIVE_YEAR_MONTH_NULL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '凍結年月 未記入,最初に保存してください'
          )
        } else if (res.response.data.message == 'ARCHIVE_YEAR_MONTH_ILLEGAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '過去の凍結年月は選択できません'
          )
        } else if (res.response.data.message == 'CAN_NOT_CANCEL_CONFIRM') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '売掛金の消込処理が終わりましたので、承認取消ができません。'
          )
        } else {
          this.$message('', 'ハンドAR作成失敗')
        }
      }
    },
    confirm() {
      this.$http
        .put(`/arap/finance/confirm/${this.query.id}`)
        .then(() => {
          this.$message('', 'ARの承認が完了しました。')
          this.load()
        })
        .catch(this.catch)
    },
    cancelConfirm() {
      this.$http
        .put(`/arap/finance/cancel-confirm/${this.query.id}`)
        .then(() => {
          this.$message('', '取消承ARの承認取消が完了しました。')
          this.load()
        })
        .catch(this.catch)
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          status: ['CANCEL', 'CONFLICT'],
        },
        paramsSerializer: (params) => {
          return this.$qs.stringify(params, { indices: false })
        },
      }
    },
    checkData() {
      if (!this.query.documentType) {
        this.$message('', 'document Type 未記入')
        return false
      } else if (!this.query.buId) {
        this.$message('', 'BU 未記入')
        return false
      } else if (!this.query.currencyCode) {
        this.$message('', 'currency Code 未記入')
        return false
      } else if (!this.query.archiveYearMonth) {
        this.$message('', '凍結年月 未記入')
        return false
      } else if (this.query.archiveYearMonth.length != 6) {
        this.$message('', '凍結年月 不正な形式')
        return false
      } else if (
        this.query.archiveYearMonth.localeCompare(this.currentMonth) === -1
      ) {
        this.$message('', '過去の凍結年月は選択できません')
        return false
      } else if (
        this.query.untaxedAmount1 == null &&
        this.query.untaxedAmount2 == null &&
        this.query.untaxedAmount3 == null &&
        this.query.untaxedAmount4 == null &&
        this.query.untaxedAmount5 == null &&
        this.query.taxedAmount1 == null &&
        this.query.taxedAmount2 == null &&
        this.query.taxedAmount3 == null &&
        this.query.taxedAmount4 == null &&
        this.query.taxedAmount5 == null
      ) {
        this.$message('', '金額必須')
        return false
      } else if (this.total == 0) {
        this.$message('', '金額必須')
        return false
      }
      return true
    },
  },
  computed: {
    currentMonth() {
      return new Date().format('yyyyMM')
    },
    isAdmin() {
      var a = 'UAC102773' === this.$store.getters.user.userAccountId
      var b = 'UAC102770' === this.$store.getters.user.userAccountId
      var c = 'UAC102774' === this.$store.getters.user.userAccountId
      return this.$isAdmin() || a || b || c
    },
    forzen() {
      return this.query.isArchived == true
    },
    tax1() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(Number(this.query.taxedAmount1 || 0) * this.taxRate)
      } else {
        return (
          Math.round(
            Number(this.query.taxedAmount1 || 0) * this.taxRate * 100
          ) / 100
        )
      }
    },
    tax2() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(Number(this.query.taxedAmount2 || 0) * this.taxRate)
      } else {
        return (
          Math.round(
            Number(this.query.taxedAmount2 || 0) * this.taxRate * 100
          ) / 100
        )
      }
    },
    tax3() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(Number(this.query.taxedAmount3 || 0) * this.taxRate)
      } else {
        return (
          Math.round(
            Number(this.query.taxedAmount3 || 0) * this.taxRate * 100
          ) / 100
        )
      }
    },
    tax4() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(Number(this.query.taxedAmount4 || 0) * this.taxRate)
      } else {
        return (
          Math.round(
            Number(this.query.taxedAmount4 || 0) * this.taxRate * 100
          ) / 100
        )
      }
    },
    tax5() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(Number(this.query.taxedAmount5 || 0) * this.taxRate)
      } else {
        return (
          Math.round(
            Number(this.query.taxedAmount5 || 0) * this.taxRate * 100
          ) / 100
        )
      }
    },
    total1() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount1 || 0) +
            Number(this.query.untaxedAmount1 || 0) +
            this.tax1
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount1 || 0) +
              Number(this.query.untaxedAmount1 || 0) +
              this.tax1) *
              100
          ) / 100
        )
      }
    },
    total2() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount2 || 0) +
            Number(this.query.untaxedAmount2 || 0) +
            this.tax2
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount2 || 0) +
              Number(this.query.untaxedAmount2 || 0) +
              this.tax2) *
              100
          ) / 100
        )
      }
    },
    total3() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount3 || 0) +
            Number(this.query.untaxedAmount3 || 0) +
            this.tax3
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount3 || 0) +
              Number(this.query.untaxedAmount3 || 0) +
              this.tax3) *
              100
          ) / 100
        )
      }
    },
    total4() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount4 || 0) +
            Number(this.query.untaxedAmount4 || 0) +
            this.tax4
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount4 || 0) +
              Number(this.query.untaxedAmount4 || 0) +
              this.tax4) *
              100
          ) / 100
        )
      }
    },
    total5() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount5 || 0) +
            Number(this.query.untaxedAmount5 || 0) +
            this.tax5
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount5 || 0) +
              Number(this.query.untaxedAmount5 || 0) +
              this.tax5) *
              100
          ) / 100
        )
      }
    },
    untaxed() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.untaxedAmount1 || 0) +
            Number(this.query.untaxedAmount2 || 0) +
            Number(this.query.untaxedAmount3 || 0) +
            Number(this.query.untaxedAmount4 || 0) +
            Number(this.query.untaxedAmount5 || 0)
        )
      } else {
        return (
          Math.round(
            (Number(this.query.untaxedAmount1 || 0) +
              Number(this.query.untaxedAmount2 || 0) +
              Number(this.query.untaxedAmount3 || 0) +
              Number(this.query.untaxedAmount4 || 0) +
              Number(this.query.untaxedAmount5 || 0)) *
              100
          ) / 100
        )
      }
    },
    taxed() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.query.taxedAmount1 || 0) +
            Number(this.query.taxedAmount2 || 0) +
            Number(this.query.taxedAmount3 || 0) +
            Number(this.query.taxedAmount4 || 0) +
            Number(this.query.taxedAmount5 || 0)
        )
      } else {
        return (
          Math.round(
            (Number(this.query.taxedAmount1 || 0) +
              Number(this.query.taxedAmount2 || 0) +
              Number(this.query.taxedAmount3 || 0) +
              Number(this.query.taxedAmount4 || 0) +
              Number(this.query.taxedAmount5 || 0)) *
              100
          ) / 100
        )
      }
    },
    tax() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          this.tax1 + this.tax2 + this.tax3 + this.tax4 + this.tax5
        )
      } else {
        return (
          Math.round(
            (this.tax1 + this.tax2 + this.tax3 + this.tax4 + this.tax5) * 100
          ) / 100
        )
      }
    },
    total() {
      if (this.query.currencyCode === 'JPY') {
        return Math.round(
          Number(this.untaxed) + Number(this.taxed) + Number(this.tax)
        )
      } else {
        return (
          Math.round(
            (Number(this.untaxed) + Number(this.taxed) + Number(this.tax)) * 100
          ) / 100
        )
      }
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.search()
    },
  },
  mounted() {
    this.$loadParams()
    this.load()
  },
}
</script>
<style scoped></style>
